import { IEirSalesPrequalResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesPrequalResponse";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { EBroadbandTechnology } from "@features/cart/ICart";

export const mapEirSalesPrequal = (response: IEirSalesPrequalResponse): IEirSalesPrequal => ({
    prequalId: response.prequalId,
    hasBroadbandService: Boolean(
        response.services.find((service) => service.broadbandTechnology === EBroadbandTechnology.FTTH)
    ),
    address: {
        eircode: response.address.eirCode,
        county: response.address.county,
        town: response.address.town,
        addressLine1: response.address.addressLine1,
        addressLine2: response.address.addressLine2,
        addressLine3: response.address.addressLine3,
    },
});
